import { lazy } from 'react';

export const NotAuthenticatedPage = lazy(() => import('./controller.js'));
